import { getRequest } from '../request/request.service';
import { User } from './user.service.types';

export const USER_URL = 'users';

export async function getUser() {
  return getRequest<User>(`${USER_URL}/user_data`);
}
